import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { ViewportProvider } from '@inter-ikea-guida/framework';
import { Results as ResultsComponent } from '../../components/Results/Results';
import LoadingIndicator from '../LoadingIndicator';
const Results = () => (_jsx(Suspense, { fallback: _jsx(LoadingIndicator, {}), children: _jsx(ViewportProvider, { children: _jsx(ResultsComponent, {}) }) }));
export default Results;
//# sourceMappingURL=Results.js.map